import React, { useEffect, useRef, useState } from 'react';
import styles from './App.module.css';
import { CART_DEFAULT, ITEMS, PERSONALIZATIONS_DEFAULT } from './App.constants';
import { calcTotalPrice, createCheckout } from './helpers';

// import LOGO from './assets/images/logo-dark.png';

const App = () => {
  const [busy, setBusy] = useState(false);

  const cardRefs = useRef([]);

  const [cart, setCart] = useState(CART_DEFAULT);
  const [personalizations, setPersonalizations] = useState(PERSONALIZATIONS_DEFAULT);
  const [successCheckout, setSuccessCheckout] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setSuccessCheckout(window.location.pathname === '/success');
  }, []);

  useEffect(() => {
    if (!cardRefs?.current?.length) return;
    cardRefs.current[currentIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }, [currentIndex]);

  const amount = (cardId, amount) => {
    setCart((prev) => ({
      ...prev,
      [cardId]: Math.max(0, prev[cardId] + amount),
    }));
  };

  const updatePersonalizations = (cardId, index, text) => {
    setPersonalizations((previous) => {
      const nextPersonalizations = [...previous[cardId]];
      nextPersonalizations[index] = text
        .replace(/founders/gi, '')
        .replace(/satoshi/gi, '')
        .slice(0, 16)
        .toUpperCase();

      return {
        ...previous,
        [cardId]: nextPersonalizations,
      };
    });
  };

  const handleSubmit = async () => {
    setBusy(true);
    await createCheckout(cart, personalizations);
    setBusy(false);
  };

  const totalPrice = calcTotalPrice(cart, personalizations);
  const isSubmitDisabled = totalPrice === 0 || busy;

  return !successCheckout ? (
    <div className={styles.app}>
      <header>
        {/* <img alt="Split|Pass" src={LOGO} className={styles.logo} /> */}
        <p className={styles.slogan}>
          Get your official <strong>split|Card</strong> & secure your secrets today!
        </p>

        <div className={styles.tabs}>
          {ITEMS.map(({ id, name }, index) => (
            <span
              className={index === currentIndex ? `${styles.current} ${styles[id]}` : undefined}
              onClick={() => setCurrentIndex(index)}
            >
              {name}
            </span>
          ))}
        </div>
      </header>

      <main className={styles.items}>
        {ITEMS.map(({ features = [], name, id, price }, index) => (
          <div key={id} ref={(el) => (cardRefs.current[index] = el)} className={styles.item}>
            <div className={`${styles.card} ${styles[id]}`}>
              <div>
                <strong>split|Card</strong>
                <i class="mdi mdi-nfc-variant" />
                <div className={styles.details}>
                  <small>0000 0000 0000 00</small>
                  <small>{personalizations[id][0] || 'SATOSHI LTD.'}</small>
                </div>
              </div>
            </div>

            <div className={styles.info}>
              <header className={styles.header}>
                <block>
                  <h2>{name}</h2>
                  <small>From ${price.toFixed(2)}</small>
                </block>

                <div>
                  <button disabled={cart[id] === 0} onClick={() => amount(id, -1)} className={styles[id]}>
                    <i class="mdi mdi-minus" />
                  </button>
                  <strong className={styles.amount}>{cart[id]}</strong>
                  <button disabled={cart[id] >= 3} onClick={() => amount(id, 1)} className={styles[id]}>
                    <i class="mdi mdi-plus" />
                  </button>
                </div>
              </header>

              <section className={styles.features}>
                {features.map(({ icon, text, caption }) => (
                  <div className={styles.feature}>
                    <i className={`mdi ${icon} ${styles.icon} ${styles[id]}`} />
                    <block>
                      <p>{text}</p>
                      <small>{caption}</small>
                    </block>
                  </div>
                ))}
              </section>
            </div>

            {cart[id] > 0 && (
              <footer className={styles.personalization}>
                <h3>Customization</h3>
                <small>You can customize your cards for just $3.99 each</small>

                {Array.from({ length: cart[id] }).map((_, index) => (
                  <input
                    key={index}
                    maxLength={16}
                    placeholder="Customize here..."
                    type="text"
                    value={personalizations[id][index] || ''}
                    onChange={({ target: { value } }) => updatePersonalizations(id, index, value)}
                  />
                ))}
              </footer>
            )}
          </div>
        ))}
      </main>

      <footer className={styles.footer}>
        <div>
          <h2>${totalPrice.toFixed(2)}</h2>
          <small>Includes taxes & shipping</small>
        </div>

        <button disabled={isSubmitDisabled} onClick={handleSubmit}>
          <i className="mdi mdi-credit-card-outline" />
          {` Checkout with Stripe`}
        </button>
      </footer>
    </div>
  ) : (
    <div className={styles.app}>
      {/* <header>
        <img alt="Split|Pass" src={LOGO} className={styles.logo} />
      </header> */}

      <div className={styles.banner}>
        <i className="mdi mdi-check-circle" />
        <h2>Payment Successful!</h2>
        <p>
          Your Split|Cards are on their way! No need to worry about shipping or customs fees—everything is included.
          Expect delivery in about 2 weeks.
        </p>
        <small>While waiting for your cards, you can start using split|pass to prepare and store your secrets!</small>
      </div>
    </div>
  );
};

export default App;
